module.exports = __webpack_public_path__ + "static/media/pagimovel-clientes.b56b92e8.png";